module.exports = __webpack_public_path__ + "img/sci_fi.736d18c4.svg";